import { render } from "./EscolhaPagamento.vue?vue&type=template&id=65cbbc62&ts=true"
import script from "./EscolhaPagamento.vue?vue&type=script&lang=ts"
export * from "./EscolhaPagamento.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/autoatendimento.totalvia.com.br/TotemAtendimento/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__